import React from "react";

import FinancialHistoryPage from "./FinancialHistoryPage";

export default function AdminHistoryPage() {
  return <FinancialHistoryPage isAdmin />;
}
